/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as VerificationRouteImport } from './routes/verification'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as SignOutRouteImport } from './routes/sign-out'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as OurStoryRouteImport } from './routes/our-story'
import { Route as OurEthosRouteImport } from './routes/our-ethos'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as HowItWorksRouteImport } from './routes/how-it-works'
import { Route as FoundingVenuesRouteImport } from './routes/founding-venues'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as EarlyaccessvenueRouteImport } from './routes/earlyaccessvenue'
import { Route as EarlyaccessartistRouteImport } from './routes/earlyaccessartist'
import { Route as EarlyaccessRouteImport } from './routes/earlyaccess'
import { Route as DisputeResolutionRouteImport } from './routes/dispute-resolution'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CommunityGuidelinesRouteImport } from './routes/community-guidelines'
import { Route as BillingRouteImport } from './routes/billing'
import { Route as AvailabilityRouteImport } from './routes/availability'
import { Route as ArtistBillingRouteImport } from './routes/artist-billing'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ToursIndexRouteImport } from './routes/tours/index'
import { Route as RipplesIndexRouteImport } from './routes/ripples/index'
import { Route as RecapsIndexRouteImport } from './routes/recaps/index'
import { Route as ProfileIndexRouteImport } from './routes/profile/index'
import { Route as InboxIndexRouteImport } from './routes/inbox/index'
import { Route as ExploreIndexRouteImport } from './routes/explore/index'
import { Route as ExchangesIndexRouteImport } from './routes/exchanges/index'
import { Route as EventsIndexRouteImport } from './routes/events/index'
import { Route as BrowseIndexRouteImport } from './routes/browse/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as VenuesSlugRouteImport } from './routes/venues/$slug'
import { Route as ToursNewRouteImport } from './routes/tours/new'
import { Route as ToursIdRouteImport } from './routes/tours/$id'
import { Route as SettingsSecurityRouteImport } from './routes/settings/security'
import { Route as SettingsReferralsRouteImport } from './routes/settings/referrals'
import { Route as SettingsPrivacyRouteImport } from './routes/settings/privacy'
import { Route as SettingsNotificationsRouteImport } from './routes/settings/notifications'
import { Route as SettingsEarningsRouteImport } from './routes/settings/earnings'
import { Route as SettingsAppearanceRouteImport } from './routes/settings/appearance'
import { Route as SettingsAccountRouteImport } from './routes/settings/account'
import { Route as RipplesSlugRouteImport } from './routes/ripples/$slug'
import { Route as RequestVenueIdRouteImport } from './routes/request/$venueId'
import { Route as RecapsSlugRouteImport } from './routes/recaps/$slug'
import { Route as ProfileEditRouteImport } from './routes/profile/edit'
import { Route as OnboardingHostRouteImport } from './routes/onboarding/host'
import { Route as OnboardingArtistRouteImport } from './routes/onboarding/artist'
import { Route as InboxThreadIdRouteImport } from './routes/inbox/$threadId'
import { Route as HostDashboardRouteImport } from './routes/host/dashboard'
import { Route as HostAvailabilityRouteImport } from './routes/host/availability'
import { Route as ExploreSlugRouteImport } from './routes/explore/$slug'
import { Route as ExchangesIdRouteImport } from './routes/exchanges/$id'
import { Route as EventsIdRouteImport } from './routes/events/$id'
import { Route as DisputesOpenRouteImport } from './routes/disputes/open'
import { Route as DisputesIdRouteImport } from './routes/disputes/$id'
import { Route as CertificatesExchangeIdRouteImport } from './routes/certificates/$exchangeId'
import { Route as BrowseArtistsRouteImport } from './routes/browse/artists'
import { Route as ArtistsSlugRouteImport } from './routes/artists/$slug'
import { Route as AdminVenuesRouteImport } from './routes/admin/venues'
import { Route as AdminSweepersRouteImport } from './routes/admin/sweepers'
import { Route as AdminSubscriptionsRouteImport } from './routes/admin/subscriptions'
import { Route as AdminSettingsRouteImport } from './routes/admin/settings'
import { Route as AdminReportsRouteImport } from './routes/admin/reports'
import { Route as AdminReferralsRouteImport } from './routes/admin/referrals'
import { Route as AdminReferralPayoutsRouteImport } from './routes/admin/referral-payouts'
import { Route as AdminLeadsRouteImport } from './routes/admin/leads'
import { Route as AdminLaunchRouteImport } from './routes/admin/launch'
import { Route as AdminImageStudioRouteImport } from './routes/admin/image-studio'
import { Route as AdminFeedbackRouteImport } from './routes/admin/feedback'
import { Route as AdminExchangesRouteImport } from './routes/admin/exchanges'
import { Route as AdminCohortRouteImport } from './routes/admin/cohort'
import { Route as AdminBillingReconciliationRouteImport } from './routes/admin/billing-reconciliation'
import { Route as AdminAuditLogRouteImport } from './routes/admin/audit-log'
import { Route as AdminAnnouncementsRouteImport } from './routes/admin/announcements'
import { Route as AdminAnalyticsEventsRouteImport } from './routes/admin/analytics-events'
import { Route as AdminAnalyticsRouteImport } from './routes/admin/analytics'
import { Route as HostVenuesIndexRouteImport } from './routes/host/venues/index'
import { Route as HostEventsIndexRouteImport } from './routes/host/events/index'
import { Route as AdminVerificationsIndexRouteImport } from './routes/admin/verifications/index'
import { Route as AdminUsersIndexRouteImport } from './routes/admin/users/index'
import { Route as AdminDisputesIndexRouteImport } from './routes/admin/disputes/index'
import { Route as ToursIdEditRouteImport } from './routes/tours/$id_.edit'
import { Route as HostVenuesNewRouteImport } from './routes/host/venues/new'
import { Route as HostEventsNewRouteImport } from './routes/host/events/new'
import { Route as ExchangesIdReviewRouteImport } from './routes/exchanges/$id_.review'
import { Route as ExchangesIdRecapRouteImport } from './routes/exchanges/$id_.recap'
import { Route as AdminVerificationsIdRouteImport } from './routes/admin/verifications/$id'
import { Route as AdminUsersIdRouteImport } from './routes/admin/users/$id'
import { Route as AdminDisputesIdRouteImport } from './routes/admin/disputes/$id'
import { Route as HostVenuesIdPreviewRouteImport } from './routes/host/venues/$id.preview'
import { Route as HostVenuesIdEditRouteImport } from './routes/host/venues/$id.edit'
import { Route as HostEventsIdManageRouteImport } from './routes/host/events/$id.manage'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const VerificationRoute = VerificationRouteImport.update({
  id: '/verification',
  path: '/verification',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const SignOutRoute = SignOutRouteImport.update({
  id: '/sign-out',
  path: '/sign-out',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const OurStoryRoute = OurStoryRouteImport.update({
  id: '/our-story',
  path: '/our-story',
  getParentRoute: () => rootRouteImport,
} as any)
const OurEthosRoute = OurEthosRouteImport.update({
  id: '/our-ethos',
  path: '/our-ethos',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const HowItWorksRoute = HowItWorksRouteImport.update({
  id: '/how-it-works',
  path: '/how-it-works',
  getParentRoute: () => rootRouteImport,
} as any)
const FoundingVenuesRoute = FoundingVenuesRouteImport.update({
  id: '/founding-venues',
  path: '/founding-venues',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqRoute = FaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => rootRouteImport,
} as any)
const EarlyaccessvenueRoute = EarlyaccessvenueRouteImport.update({
  id: '/earlyaccessvenue',
  path: '/earlyaccessvenue',
  getParentRoute: () => rootRouteImport,
} as any)
const EarlyaccessartistRoute = EarlyaccessartistRouteImport.update({
  id: '/earlyaccessartist',
  path: '/earlyaccessartist',
  getParentRoute: () => rootRouteImport,
} as any)
const EarlyaccessRoute = EarlyaccessRouteImport.update({
  id: '/earlyaccess',
  path: '/earlyaccess',
  getParentRoute: () => rootRouteImport,
} as any)
const DisputeResolutionRoute = DisputeResolutionRouteImport.update({
  id: '/dispute-resolution',
  path: '/dispute-resolution',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const CommunityGuidelinesRoute = CommunityGuidelinesRouteImport.update({
  id: '/community-guidelines',
  path: '/community-guidelines',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingRoute = BillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => rootRouteImport,
} as any)
const AvailabilityRoute = AvailabilityRouteImport.update({
  id: '/availability',
  path: '/availability',
  getParentRoute: () => rootRouteImport,
} as any)
const ArtistBillingRoute = ArtistBillingRouteImport.update({
  id: '/artist-billing',
  path: '/artist-billing',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ToursIndexRoute = ToursIndexRouteImport.update({
  id: '/tours/',
  path: '/tours/',
  getParentRoute: () => rootRouteImport,
} as any)
const RipplesIndexRoute = RipplesIndexRouteImport.update({
  id: '/ripples/',
  path: '/ripples/',
  getParentRoute: () => rootRouteImport,
} as any)
const RecapsIndexRoute = RecapsIndexRouteImport.update({
  id: '/recaps/',
  path: '/recaps/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileIndexRoute = ProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxIndexRoute = InboxIndexRouteImport.update({
  id: '/inbox/',
  path: '/inbox/',
  getParentRoute: () => rootRouteImport,
} as any)
const ExploreIndexRoute = ExploreIndexRouteImport.update({
  id: '/explore/',
  path: '/explore/',
  getParentRoute: () => rootRouteImport,
} as any)
const ExchangesIndexRoute = ExchangesIndexRouteImport.update({
  id: '/exchanges/',
  path: '/exchanges/',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsIndexRoute = EventsIndexRouteImport.update({
  id: '/events/',
  path: '/events/',
  getParentRoute: () => rootRouteImport,
} as any)
const BrowseIndexRoute = BrowseIndexRouteImport.update({
  id: '/browse/',
  path: '/browse/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const VenuesSlugRoute = VenuesSlugRouteImport.update({
  id: '/venues/$slug',
  path: '/venues/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const ToursNewRoute = ToursNewRouteImport.update({
  id: '/tours/new',
  path: '/tours/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ToursIdRoute = ToursIdRouteImport.update({
  id: '/tours/$id',
  path: '/tours/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsSecurityRoute = SettingsSecurityRouteImport.update({
  id: '/settings/security',
  path: '/settings/security',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsReferralsRoute = SettingsReferralsRouteImport.update({
  id: '/settings/referrals',
  path: '/settings/referrals',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsPrivacyRoute = SettingsPrivacyRouteImport.update({
  id: '/settings/privacy',
  path: '/settings/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsNotificationsRoute = SettingsNotificationsRouteImport.update({
  id: '/settings/notifications',
  path: '/settings/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsEarningsRoute = SettingsEarningsRouteImport.update({
  id: '/settings/earnings',
  path: '/settings/earnings',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsAppearanceRoute = SettingsAppearanceRouteImport.update({
  id: '/settings/appearance',
  path: '/settings/appearance',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsAccountRoute = SettingsAccountRouteImport.update({
  id: '/settings/account',
  path: '/settings/account',
  getParentRoute: () => rootRouteImport,
} as any)
const RipplesSlugRoute = RipplesSlugRouteImport.update({
  id: '/ripples/$slug',
  path: '/ripples/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const RequestVenueIdRoute = RequestVenueIdRouteImport.update({
  id: '/request/$venueId',
  path: '/request/$venueId',
  getParentRoute: () => rootRouteImport,
} as any)
const RecapsSlugRoute = RecapsSlugRouteImport.update({
  id: '/recaps/$slug',
  path: '/recaps/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileEditRoute = ProfileEditRouteImport.update({
  id: '/profile/edit',
  path: '/profile/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingHostRoute = OnboardingHostRouteImport.update({
  id: '/onboarding/host',
  path: '/onboarding/host',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingArtistRoute = OnboardingArtistRouteImport.update({
  id: '/onboarding/artist',
  path: '/onboarding/artist',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxThreadIdRoute = InboxThreadIdRouteImport.update({
  id: '/inbox/$threadId',
  path: '/inbox/$threadId',
  getParentRoute: () => rootRouteImport,
} as any)
const HostDashboardRoute = HostDashboardRouteImport.update({
  id: '/host/dashboard',
  path: '/host/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const HostAvailabilityRoute = HostAvailabilityRouteImport.update({
  id: '/host/availability',
  path: '/host/availability',
  getParentRoute: () => rootRouteImport,
} as any)
const ExploreSlugRoute = ExploreSlugRouteImport.update({
  id: '/explore/$slug',
  path: '/explore/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const ExchangesIdRoute = ExchangesIdRouteImport.update({
  id: '/exchanges/$id',
  path: '/exchanges/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsIdRoute = EventsIdRouteImport.update({
  id: '/events/$id',
  path: '/events/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const DisputesOpenRoute = DisputesOpenRouteImport.update({
  id: '/disputes/open',
  path: '/disputes/open',
  getParentRoute: () => rootRouteImport,
} as any)
const DisputesIdRoute = DisputesIdRouteImport.update({
  id: '/disputes/$id',
  path: '/disputes/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const CertificatesExchangeIdRoute = CertificatesExchangeIdRouteImport.update({
  id: '/certificates/$exchangeId',
  path: '/certificates/$exchangeId',
  getParentRoute: () => rootRouteImport,
} as any)
const BrowseArtistsRoute = BrowseArtistsRouteImport.update({
  id: '/browse/artists',
  path: '/browse/artists',
  getParentRoute: () => rootRouteImport,
} as any)
const ArtistsSlugRoute = ArtistsSlugRouteImport.update({
  id: '/artists/$slug',
  path: '/artists/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminVenuesRoute = AdminVenuesRouteImport.update({
  id: '/admin/venues',
  path: '/admin/venues',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSweepersRoute = AdminSweepersRouteImport.update({
  id: '/admin/sweepers',
  path: '/admin/sweepers',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSubscriptionsRoute = AdminSubscriptionsRouteImport.update({
  id: '/admin/subscriptions',
  path: '/admin/subscriptions',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/admin/settings',
  path: '/admin/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminReportsRoute = AdminReportsRouteImport.update({
  id: '/admin/reports',
  path: '/admin/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminReferralsRoute = AdminReferralsRouteImport.update({
  id: '/admin/referrals',
  path: '/admin/referrals',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminReferralPayoutsRoute = AdminReferralPayoutsRouteImport.update({
  id: '/admin/referral-payouts',
  path: '/admin/referral-payouts',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminLeadsRoute = AdminLeadsRouteImport.update({
  id: '/admin/leads',
  path: '/admin/leads',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminLaunchRoute = AdminLaunchRouteImport.update({
  id: '/admin/launch',
  path: '/admin/launch',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminImageStudioRoute = AdminImageStudioRouteImport.update({
  id: '/admin/image-studio',
  path: '/admin/image-studio',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminFeedbackRoute = AdminFeedbackRouteImport.update({
  id: '/admin/feedback',
  path: '/admin/feedback',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminExchangesRoute = AdminExchangesRouteImport.update({
  id: '/admin/exchanges',
  path: '/admin/exchanges',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCohortRoute = AdminCohortRouteImport.update({
  id: '/admin/cohort',
  path: '/admin/cohort',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminBillingReconciliationRoute =
  AdminBillingReconciliationRouteImport.update({
    id: '/admin/billing-reconciliation',
    path: '/admin/billing-reconciliation',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminAuditLogRoute = AdminAuditLogRouteImport.update({
  id: '/admin/audit-log',
  path: '/admin/audit-log',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAnnouncementsRoute = AdminAnnouncementsRouteImport.update({
  id: '/admin/announcements',
  path: '/admin/announcements',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAnalyticsEventsRoute = AdminAnalyticsEventsRouteImport.update({
  id: '/admin/analytics-events',
  path: '/admin/analytics-events',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAnalyticsRoute = AdminAnalyticsRouteImport.update({
  id: '/admin/analytics',
  path: '/admin/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const HostVenuesIndexRoute = HostVenuesIndexRouteImport.update({
  id: '/host/venues/',
  path: '/host/venues/',
  getParentRoute: () => rootRouteImport,
} as any)
const HostEventsIndexRoute = HostEventsIndexRouteImport.update({
  id: '/host/events/',
  path: '/host/events/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminVerificationsIndexRoute = AdminVerificationsIndexRouteImport.update({
  id: '/admin/verifications/',
  path: '/admin/verifications/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
  id: '/admin/users/',
  path: '/admin/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminDisputesIndexRoute = AdminDisputesIndexRouteImport.update({
  id: '/admin/disputes/',
  path: '/admin/disputes/',
  getParentRoute: () => rootRouteImport,
} as any)
const ToursIdEditRoute = ToursIdEditRouteImport.update({
  id: '/tours/$id_/edit',
  path: '/tours/$id/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const HostVenuesNewRoute = HostVenuesNewRouteImport.update({
  id: '/host/venues/new',
  path: '/host/venues/new',
  getParentRoute: () => rootRouteImport,
} as any)
const HostEventsNewRoute = HostEventsNewRouteImport.update({
  id: '/host/events/new',
  path: '/host/events/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ExchangesIdReviewRoute = ExchangesIdReviewRouteImport.update({
  id: '/exchanges/$id_/review',
  path: '/exchanges/$id/review',
  getParentRoute: () => rootRouteImport,
} as any)
const ExchangesIdRecapRoute = ExchangesIdRecapRouteImport.update({
  id: '/exchanges/$id_/recap',
  path: '/exchanges/$id/recap',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminVerificationsIdRoute = AdminVerificationsIdRouteImport.update({
  id: '/admin/verifications/$id',
  path: '/admin/verifications/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersIdRoute = AdminUsersIdRouteImport.update({
  id: '/admin/users/$id',
  path: '/admin/users/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminDisputesIdRoute = AdminDisputesIdRouteImport.update({
  id: '/admin/disputes/$id',
  path: '/admin/disputes/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const HostVenuesIdPreviewRoute = HostVenuesIdPreviewRouteImport.update({
  id: '/host/venues/$id/preview',
  path: '/host/venues/$id/preview',
  getParentRoute: () => rootRouteImport,
} as any)
const HostVenuesIdEditRoute = HostVenuesIdEditRouteImport.update({
  id: '/host/venues/$id/edit',
  path: '/host/venues/$id/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const HostEventsIdManageRoute = HostEventsIdManageRouteImport.update({
  id: '/host/events/$id/manage',
  path: '/host/events/$id/manage',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/artist-billing': typeof ArtistBillingRoute
  '/availability': typeof AvailabilityRoute
  '/billing': typeof BillingRoute
  '/community-guidelines': typeof CommunityGuidelinesRoute
  '/dashboard': typeof DashboardRoute
  '/dispute-resolution': typeof DisputeResolutionRoute
  '/earlyaccess': typeof EarlyaccessRoute
  '/earlyaccessartist': typeof EarlyaccessartistRoute
  '/earlyaccessvenue': typeof EarlyaccessvenueRoute
  '/faq': typeof FaqRoute
  '/founding-venues': typeof FoundingVenuesRoute
  '/how-it-works': typeof HowItWorksRoute
  '/notifications': typeof NotificationsRoute
  '/our-ethos': typeof OurEthosRoute
  '/our-story': typeof OurStoryRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-out': typeof SignOutRoute
  '/sign-up': typeof SignUpRoute
  '/terms': typeof TermsRoute
  '/verification': typeof VerificationRoute
  '/verify-email': typeof VerifyEmailRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/analytics-events': typeof AdminAnalyticsEventsRoute
  '/admin/announcements': typeof AdminAnnouncementsRoute
  '/admin/audit-log': typeof AdminAuditLogRoute
  '/admin/billing-reconciliation': typeof AdminBillingReconciliationRoute
  '/admin/cohort': typeof AdminCohortRoute
  '/admin/exchanges': typeof AdminExchangesRoute
  '/admin/feedback': typeof AdminFeedbackRoute
  '/admin/image-studio': typeof AdminImageStudioRoute
  '/admin/launch': typeof AdminLaunchRoute
  '/admin/leads': typeof AdminLeadsRoute
  '/admin/referral-payouts': typeof AdminReferralPayoutsRoute
  '/admin/referrals': typeof AdminReferralsRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/subscriptions': typeof AdminSubscriptionsRoute
  '/admin/sweepers': typeof AdminSweepersRoute
  '/admin/venues': typeof AdminVenuesRoute
  '/artists/$slug': typeof ArtistsSlugRoute
  '/browse/artists': typeof BrowseArtistsRoute
  '/certificates/$exchangeId': typeof CertificatesExchangeIdRoute
  '/disputes/$id': typeof DisputesIdRoute
  '/disputes/open': typeof DisputesOpenRoute
  '/events/$id': typeof EventsIdRoute
  '/exchanges/$id': typeof ExchangesIdRoute
  '/explore/$slug': typeof ExploreSlugRoute
  '/host/availability': typeof HostAvailabilityRoute
  '/host/dashboard': typeof HostDashboardRoute
  '/inbox/$threadId': typeof InboxThreadIdRoute
  '/onboarding/artist': typeof OnboardingArtistRoute
  '/onboarding/host': typeof OnboardingHostRoute
  '/profile/edit': typeof ProfileEditRoute
  '/recaps/$slug': typeof RecapsSlugRoute
  '/request/$venueId': typeof RequestVenueIdRoute
  '/ripples/$slug': typeof RipplesSlugRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/earnings': typeof SettingsEarningsRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/privacy': typeof SettingsPrivacyRoute
  '/settings/referrals': typeof SettingsReferralsRoute
  '/settings/security': typeof SettingsSecurityRoute
  '/tours/$id': typeof ToursIdRoute
  '/tours/new': typeof ToursNewRoute
  '/venues/$slug': typeof VenuesSlugRoute
  '/admin/': typeof AdminIndexRoute
  '/browse/': typeof BrowseIndexRoute
  '/events/': typeof EventsIndexRoute
  '/exchanges/': typeof ExchangesIndexRoute
  '/explore/': typeof ExploreIndexRoute
  '/inbox/': typeof InboxIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/recaps/': typeof RecapsIndexRoute
  '/ripples/': typeof RipplesIndexRoute
  '/tours/': typeof ToursIndexRoute
  '/admin/disputes/$id': typeof AdminDisputesIdRoute
  '/admin/users/$id': typeof AdminUsersIdRoute
  '/admin/verifications/$id': typeof AdminVerificationsIdRoute
  '/exchanges/$id/recap': typeof ExchangesIdRecapRoute
  '/exchanges/$id/review': typeof ExchangesIdReviewRoute
  '/host/events/new': typeof HostEventsNewRoute
  '/host/venues/new': typeof HostVenuesNewRoute
  '/tours/$id/edit': typeof ToursIdEditRoute
  '/admin/disputes/': typeof AdminDisputesIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
  '/admin/verifications/': typeof AdminVerificationsIndexRoute
  '/host/events/': typeof HostEventsIndexRoute
  '/host/venues/': typeof HostVenuesIndexRoute
  '/host/events/$id/manage': typeof HostEventsIdManageRoute
  '/host/venues/$id/edit': typeof HostVenuesIdEditRoute
  '/host/venues/$id/preview': typeof HostVenuesIdPreviewRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/artist-billing': typeof ArtistBillingRoute
  '/availability': typeof AvailabilityRoute
  '/billing': typeof BillingRoute
  '/community-guidelines': typeof CommunityGuidelinesRoute
  '/dashboard': typeof DashboardRoute
  '/dispute-resolution': typeof DisputeResolutionRoute
  '/earlyaccess': typeof EarlyaccessRoute
  '/earlyaccessartist': typeof EarlyaccessartistRoute
  '/earlyaccessvenue': typeof EarlyaccessvenueRoute
  '/faq': typeof FaqRoute
  '/founding-venues': typeof FoundingVenuesRoute
  '/how-it-works': typeof HowItWorksRoute
  '/notifications': typeof NotificationsRoute
  '/our-ethos': typeof OurEthosRoute
  '/our-story': typeof OurStoryRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-out': typeof SignOutRoute
  '/sign-up': typeof SignUpRoute
  '/terms': typeof TermsRoute
  '/verification': typeof VerificationRoute
  '/verify-email': typeof VerifyEmailRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/analytics-events': typeof AdminAnalyticsEventsRoute
  '/admin/announcements': typeof AdminAnnouncementsRoute
  '/admin/audit-log': typeof AdminAuditLogRoute
  '/admin/billing-reconciliation': typeof AdminBillingReconciliationRoute
  '/admin/cohort': typeof AdminCohortRoute
  '/admin/exchanges': typeof AdminExchangesRoute
  '/admin/feedback': typeof AdminFeedbackRoute
  '/admin/image-studio': typeof AdminImageStudioRoute
  '/admin/launch': typeof AdminLaunchRoute
  '/admin/leads': typeof AdminLeadsRoute
  '/admin/referral-payouts': typeof AdminReferralPayoutsRoute
  '/admin/referrals': typeof AdminReferralsRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/subscriptions': typeof AdminSubscriptionsRoute
  '/admin/sweepers': typeof AdminSweepersRoute
  '/admin/venues': typeof AdminVenuesRoute
  '/artists/$slug': typeof ArtistsSlugRoute
  '/browse/artists': typeof BrowseArtistsRoute
  '/certificates/$exchangeId': typeof CertificatesExchangeIdRoute
  '/disputes/$id': typeof DisputesIdRoute
  '/disputes/open': typeof DisputesOpenRoute
  '/events/$id': typeof EventsIdRoute
  '/exchanges/$id': typeof ExchangesIdRoute
  '/explore/$slug': typeof ExploreSlugRoute
  '/host/availability': typeof HostAvailabilityRoute
  '/host/dashboard': typeof HostDashboardRoute
  '/inbox/$threadId': typeof InboxThreadIdRoute
  '/onboarding/artist': typeof OnboardingArtistRoute
  '/onboarding/host': typeof OnboardingHostRoute
  '/profile/edit': typeof ProfileEditRoute
  '/recaps/$slug': typeof RecapsSlugRoute
  '/request/$venueId': typeof RequestVenueIdRoute
  '/ripples/$slug': typeof RipplesSlugRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/earnings': typeof SettingsEarningsRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/privacy': typeof SettingsPrivacyRoute
  '/settings/referrals': typeof SettingsReferralsRoute
  '/settings/security': typeof SettingsSecurityRoute
  '/tours/$id': typeof ToursIdRoute
  '/tours/new': typeof ToursNewRoute
  '/venues/$slug': typeof VenuesSlugRoute
  '/admin': typeof AdminIndexRoute
  '/browse': typeof BrowseIndexRoute
  '/events': typeof EventsIndexRoute
  '/exchanges': typeof ExchangesIndexRoute
  '/explore': typeof ExploreIndexRoute
  '/inbox': typeof InboxIndexRoute
  '/profile': typeof ProfileIndexRoute
  '/recaps': typeof RecapsIndexRoute
  '/ripples': typeof RipplesIndexRoute
  '/tours': typeof ToursIndexRoute
  '/admin/disputes/$id': typeof AdminDisputesIdRoute
  '/admin/users/$id': typeof AdminUsersIdRoute
  '/admin/verifications/$id': typeof AdminVerificationsIdRoute
  '/exchanges/$id/recap': typeof ExchangesIdRecapRoute
  '/exchanges/$id/review': typeof ExchangesIdReviewRoute
  '/host/events/new': typeof HostEventsNewRoute
  '/host/venues/new': typeof HostVenuesNewRoute
  '/tours/$id/edit': typeof ToursIdEditRoute
  '/admin/disputes': typeof AdminDisputesIndexRoute
  '/admin/users': typeof AdminUsersIndexRoute
  '/admin/verifications': typeof AdminVerificationsIndexRoute
  '/host/events': typeof HostEventsIndexRoute
  '/host/venues': typeof HostVenuesIndexRoute
  '/host/events/$id/manage': typeof HostEventsIdManageRoute
  '/host/venues/$id/edit': typeof HostVenuesIdEditRoute
  '/host/venues/$id/preview': typeof HostVenuesIdPreviewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/artist-billing': typeof ArtistBillingRoute
  '/availability': typeof AvailabilityRoute
  '/billing': typeof BillingRoute
  '/community-guidelines': typeof CommunityGuidelinesRoute
  '/dashboard': typeof DashboardRoute
  '/dispute-resolution': typeof DisputeResolutionRoute
  '/earlyaccess': typeof EarlyaccessRoute
  '/earlyaccessartist': typeof EarlyaccessartistRoute
  '/earlyaccessvenue': typeof EarlyaccessvenueRoute
  '/faq': typeof FaqRoute
  '/founding-venues': typeof FoundingVenuesRoute
  '/how-it-works': typeof HowItWorksRoute
  '/notifications': typeof NotificationsRoute
  '/our-ethos': typeof OurEthosRoute
  '/our-story': typeof OurStoryRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-out': typeof SignOutRoute
  '/sign-up': typeof SignUpRoute
  '/terms': typeof TermsRoute
  '/verification': typeof VerificationRoute
  '/verify-email': typeof VerifyEmailRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/analytics-events': typeof AdminAnalyticsEventsRoute
  '/admin/announcements': typeof AdminAnnouncementsRoute
  '/admin/audit-log': typeof AdminAuditLogRoute
  '/admin/billing-reconciliation': typeof AdminBillingReconciliationRoute
  '/admin/cohort': typeof AdminCohortRoute
  '/admin/exchanges': typeof AdminExchangesRoute
  '/admin/feedback': typeof AdminFeedbackRoute
  '/admin/image-studio': typeof AdminImageStudioRoute
  '/admin/launch': typeof AdminLaunchRoute
  '/admin/leads': typeof AdminLeadsRoute
  '/admin/referral-payouts': typeof AdminReferralPayoutsRoute
  '/admin/referrals': typeof AdminReferralsRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/subscriptions': typeof AdminSubscriptionsRoute
  '/admin/sweepers': typeof AdminSweepersRoute
  '/admin/venues': typeof AdminVenuesRoute
  '/artists/$slug': typeof ArtistsSlugRoute
  '/browse/artists': typeof BrowseArtistsRoute
  '/certificates/$exchangeId': typeof CertificatesExchangeIdRoute
  '/disputes/$id': typeof DisputesIdRoute
  '/disputes/open': typeof DisputesOpenRoute
  '/events/$id': typeof EventsIdRoute
  '/exchanges/$id': typeof ExchangesIdRoute
  '/explore/$slug': typeof ExploreSlugRoute
  '/host/availability': typeof HostAvailabilityRoute
  '/host/dashboard': typeof HostDashboardRoute
  '/inbox/$threadId': typeof InboxThreadIdRoute
  '/onboarding/artist': typeof OnboardingArtistRoute
  '/onboarding/host': typeof OnboardingHostRoute
  '/profile/edit': typeof ProfileEditRoute
  '/recaps/$slug': typeof RecapsSlugRoute
  '/request/$venueId': typeof RequestVenueIdRoute
  '/ripples/$slug': typeof RipplesSlugRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/earnings': typeof SettingsEarningsRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/privacy': typeof SettingsPrivacyRoute
  '/settings/referrals': typeof SettingsReferralsRoute
  '/settings/security': typeof SettingsSecurityRoute
  '/tours/$id': typeof ToursIdRoute
  '/tours/new': typeof ToursNewRoute
  '/venues/$slug': typeof VenuesSlugRoute
  '/admin/': typeof AdminIndexRoute
  '/browse/': typeof BrowseIndexRoute
  '/events/': typeof EventsIndexRoute
  '/exchanges/': typeof ExchangesIndexRoute
  '/explore/': typeof ExploreIndexRoute
  '/inbox/': typeof InboxIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/recaps/': typeof RecapsIndexRoute
  '/ripples/': typeof RipplesIndexRoute
  '/tours/': typeof ToursIndexRoute
  '/admin/disputes/$id': typeof AdminDisputesIdRoute
  '/admin/users/$id': typeof AdminUsersIdRoute
  '/admin/verifications/$id': typeof AdminVerificationsIdRoute
  '/exchanges/$id_/recap': typeof ExchangesIdRecapRoute
  '/exchanges/$id_/review': typeof ExchangesIdReviewRoute
  '/host/events/new': typeof HostEventsNewRoute
  '/host/venues/new': typeof HostVenuesNewRoute
  '/tours/$id_/edit': typeof ToursIdEditRoute
  '/admin/disputes/': typeof AdminDisputesIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
  '/admin/verifications/': typeof AdminVerificationsIndexRoute
  '/host/events/': typeof HostEventsIndexRoute
  '/host/venues/': typeof HostVenuesIndexRoute
  '/host/events/$id/manage': typeof HostEventsIdManageRoute
  '/host/venues/$id/edit': typeof HostVenuesIdEditRoute
  '/host/venues/$id/preview': typeof HostVenuesIdPreviewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/artist-billing'
    | '/availability'
    | '/billing'
    | '/community-guidelines'
    | '/dashboard'
    | '/dispute-resolution'
    | '/earlyaccess'
    | '/earlyaccessartist'
    | '/earlyaccessvenue'
    | '/faq'
    | '/founding-venues'
    | '/how-it-works'
    | '/notifications'
    | '/our-ethos'
    | '/our-story'
    | '/privacy'
    | '/reset-password'
    | '/sign-in'
    | '/sign-out'
    | '/sign-up'
    | '/terms'
    | '/verification'
    | '/verify-email'
    | '/admin/analytics'
    | '/admin/analytics-events'
    | '/admin/announcements'
    | '/admin/audit-log'
    | '/admin/billing-reconciliation'
    | '/admin/cohort'
    | '/admin/exchanges'
    | '/admin/feedback'
    | '/admin/image-studio'
    | '/admin/launch'
    | '/admin/leads'
    | '/admin/referral-payouts'
    | '/admin/referrals'
    | '/admin/reports'
    | '/admin/settings'
    | '/admin/subscriptions'
    | '/admin/sweepers'
    | '/admin/venues'
    | '/artists/$slug'
    | '/browse/artists'
    | '/certificates/$exchangeId'
    | '/disputes/$id'
    | '/disputes/open'
    | '/events/$id'
    | '/exchanges/$id'
    | '/explore/$slug'
    | '/host/availability'
    | '/host/dashboard'
    | '/inbox/$threadId'
    | '/onboarding/artist'
    | '/onboarding/host'
    | '/profile/edit'
    | '/recaps/$slug'
    | '/request/$venueId'
    | '/ripples/$slug'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/earnings'
    | '/settings/notifications'
    | '/settings/privacy'
    | '/settings/referrals'
    | '/settings/security'
    | '/tours/$id'
    | '/tours/new'
    | '/venues/$slug'
    | '/admin/'
    | '/browse/'
    | '/events/'
    | '/exchanges/'
    | '/explore/'
    | '/inbox/'
    | '/profile/'
    | '/recaps/'
    | '/ripples/'
    | '/tours/'
    | '/admin/disputes/$id'
    | '/admin/users/$id'
    | '/admin/verifications/$id'
    | '/exchanges/$id/recap'
    | '/exchanges/$id/review'
    | '/host/events/new'
    | '/host/venues/new'
    | '/tours/$id/edit'
    | '/admin/disputes/'
    | '/admin/users/'
    | '/admin/verifications/'
    | '/host/events/'
    | '/host/venues/'
    | '/host/events/$id/manage'
    | '/host/venues/$id/edit'
    | '/host/venues/$id/preview'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/artist-billing'
    | '/availability'
    | '/billing'
    | '/community-guidelines'
    | '/dashboard'
    | '/dispute-resolution'
    | '/earlyaccess'
    | '/earlyaccessartist'
    | '/earlyaccessvenue'
    | '/faq'
    | '/founding-venues'
    | '/how-it-works'
    | '/notifications'
    | '/our-ethos'
    | '/our-story'
    | '/privacy'
    | '/reset-password'
    | '/sign-in'
    | '/sign-out'
    | '/sign-up'
    | '/terms'
    | '/verification'
    | '/verify-email'
    | '/admin/analytics'
    | '/admin/analytics-events'
    | '/admin/announcements'
    | '/admin/audit-log'
    | '/admin/billing-reconciliation'
    | '/admin/cohort'
    | '/admin/exchanges'
    | '/admin/feedback'
    | '/admin/image-studio'
    | '/admin/launch'
    | '/admin/leads'
    | '/admin/referral-payouts'
    | '/admin/referrals'
    | '/admin/reports'
    | '/admin/settings'
    | '/admin/subscriptions'
    | '/admin/sweepers'
    | '/admin/venues'
    | '/artists/$slug'
    | '/browse/artists'
    | '/certificates/$exchangeId'
    | '/disputes/$id'
    | '/disputes/open'
    | '/events/$id'
    | '/exchanges/$id'
    | '/explore/$slug'
    | '/host/availability'
    | '/host/dashboard'
    | '/inbox/$threadId'
    | '/onboarding/artist'
    | '/onboarding/host'
    | '/profile/edit'
    | '/recaps/$slug'
    | '/request/$venueId'
    | '/ripples/$slug'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/earnings'
    | '/settings/notifications'
    | '/settings/privacy'
    | '/settings/referrals'
    | '/settings/security'
    | '/tours/$id'
    | '/tours/new'
    | '/venues/$slug'
    | '/admin'
    | '/browse'
    | '/events'
    | '/exchanges'
    | '/explore'
    | '/inbox'
    | '/profile'
    | '/recaps'
    | '/ripples'
    | '/tours'
    | '/admin/disputes/$id'
    | '/admin/users/$id'
    | '/admin/verifications/$id'
    | '/exchanges/$id/recap'
    | '/exchanges/$id/review'
    | '/host/events/new'
    | '/host/venues/new'
    | '/tours/$id/edit'
    | '/admin/disputes'
    | '/admin/users'
    | '/admin/verifications'
    | '/host/events'
    | '/host/venues'
    | '/host/events/$id/manage'
    | '/host/venues/$id/edit'
    | '/host/venues/$id/preview'
  id:
    | '__root__'
    | '/'
    | '/artist-billing'
    | '/availability'
    | '/billing'
    | '/community-guidelines'
    | '/dashboard'
    | '/dispute-resolution'
    | '/earlyaccess'
    | '/earlyaccessartist'
    | '/earlyaccessvenue'
    | '/faq'
    | '/founding-venues'
    | '/how-it-works'
    | '/notifications'
    | '/our-ethos'
    | '/our-story'
    | '/privacy'
    | '/reset-password'
    | '/sign-in'
    | '/sign-out'
    | '/sign-up'
    | '/terms'
    | '/verification'
    | '/verify-email'
    | '/admin/analytics'
    | '/admin/analytics-events'
    | '/admin/announcements'
    | '/admin/audit-log'
    | '/admin/billing-reconciliation'
    | '/admin/cohort'
    | '/admin/exchanges'
    | '/admin/feedback'
    | '/admin/image-studio'
    | '/admin/launch'
    | '/admin/leads'
    | '/admin/referral-payouts'
    | '/admin/referrals'
    | '/admin/reports'
    | '/admin/settings'
    | '/admin/subscriptions'
    | '/admin/sweepers'
    | '/admin/venues'
    | '/artists/$slug'
    | '/browse/artists'
    | '/certificates/$exchangeId'
    | '/disputes/$id'
    | '/disputes/open'
    | '/events/$id'
    | '/exchanges/$id'
    | '/explore/$slug'
    | '/host/availability'
    | '/host/dashboard'
    | '/inbox/$threadId'
    | '/onboarding/artist'
    | '/onboarding/host'
    | '/profile/edit'
    | '/recaps/$slug'
    | '/request/$venueId'
    | '/ripples/$slug'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/earnings'
    | '/settings/notifications'
    | '/settings/privacy'
    | '/settings/referrals'
    | '/settings/security'
    | '/tours/$id'
    | '/tours/new'
    | '/venues/$slug'
    | '/admin/'
    | '/browse/'
    | '/events/'
    | '/exchanges/'
    | '/explore/'
    | '/inbox/'
    | '/profile/'
    | '/recaps/'
    | '/ripples/'
    | '/tours/'
    | '/admin/disputes/$id'
    | '/admin/users/$id'
    | '/admin/verifications/$id'
    | '/exchanges/$id_/recap'
    | '/exchanges/$id_/review'
    | '/host/events/new'
    | '/host/venues/new'
    | '/tours/$id_/edit'
    | '/admin/disputes/'
    | '/admin/users/'
    | '/admin/verifications/'
    | '/host/events/'
    | '/host/venues/'
    | '/host/events/$id/manage'
    | '/host/venues/$id/edit'
    | '/host/venues/$id/preview'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ArtistBillingRoute: typeof ArtistBillingRoute
  AvailabilityRoute: typeof AvailabilityRoute
  BillingRoute: typeof BillingRoute
  CommunityGuidelinesRoute: typeof CommunityGuidelinesRoute
  DashboardRoute: typeof DashboardRoute
  DisputeResolutionRoute: typeof DisputeResolutionRoute
  EarlyaccessRoute: typeof EarlyaccessRoute
  EarlyaccessartistRoute: typeof EarlyaccessartistRoute
  EarlyaccessvenueRoute: typeof EarlyaccessvenueRoute
  FaqRoute: typeof FaqRoute
  FoundingVenuesRoute: typeof FoundingVenuesRoute
  HowItWorksRoute: typeof HowItWorksRoute
  NotificationsRoute: typeof NotificationsRoute
  OurEthosRoute: typeof OurEthosRoute
  OurStoryRoute: typeof OurStoryRoute
  PrivacyRoute: typeof PrivacyRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignInRoute: typeof SignInRoute
  SignOutRoute: typeof SignOutRoute
  SignUpRoute: typeof SignUpRoute
  TermsRoute: typeof TermsRoute
  VerificationRoute: typeof VerificationRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  AdminAnalyticsRoute: typeof AdminAnalyticsRoute
  AdminAnalyticsEventsRoute: typeof AdminAnalyticsEventsRoute
  AdminAnnouncementsRoute: typeof AdminAnnouncementsRoute
  AdminAuditLogRoute: typeof AdminAuditLogRoute
  AdminBillingReconciliationRoute: typeof AdminBillingReconciliationRoute
  AdminCohortRoute: typeof AdminCohortRoute
  AdminExchangesRoute: typeof AdminExchangesRoute
  AdminFeedbackRoute: typeof AdminFeedbackRoute
  AdminImageStudioRoute: typeof AdminImageStudioRoute
  AdminLaunchRoute: typeof AdminLaunchRoute
  AdminLeadsRoute: typeof AdminLeadsRoute
  AdminReferralPayoutsRoute: typeof AdminReferralPayoutsRoute
  AdminReferralsRoute: typeof AdminReferralsRoute
  AdminReportsRoute: typeof AdminReportsRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminSubscriptionsRoute: typeof AdminSubscriptionsRoute
  AdminSweepersRoute: typeof AdminSweepersRoute
  AdminVenuesRoute: typeof AdminVenuesRoute
  ArtistsSlugRoute: typeof ArtistsSlugRoute
  BrowseArtistsRoute: typeof BrowseArtistsRoute
  CertificatesExchangeIdRoute: typeof CertificatesExchangeIdRoute
  DisputesIdRoute: typeof DisputesIdRoute
  DisputesOpenRoute: typeof DisputesOpenRoute
  EventsIdRoute: typeof EventsIdRoute
  ExchangesIdRoute: typeof ExchangesIdRoute
  ExploreSlugRoute: typeof ExploreSlugRoute
  HostAvailabilityRoute: typeof HostAvailabilityRoute
  HostDashboardRoute: typeof HostDashboardRoute
  InboxThreadIdRoute: typeof InboxThreadIdRoute
  OnboardingArtistRoute: typeof OnboardingArtistRoute
  OnboardingHostRoute: typeof OnboardingHostRoute
  ProfileEditRoute: typeof ProfileEditRoute
  RecapsSlugRoute: typeof RecapsSlugRoute
  RequestVenueIdRoute: typeof RequestVenueIdRoute
  RipplesSlugRoute: typeof RipplesSlugRoute
  SettingsAccountRoute: typeof SettingsAccountRoute
  SettingsAppearanceRoute: typeof SettingsAppearanceRoute
  SettingsEarningsRoute: typeof SettingsEarningsRoute
  SettingsNotificationsRoute: typeof SettingsNotificationsRoute
  SettingsPrivacyRoute: typeof SettingsPrivacyRoute
  SettingsReferralsRoute: typeof SettingsReferralsRoute
  SettingsSecurityRoute: typeof SettingsSecurityRoute
  ToursIdRoute: typeof ToursIdRoute
  ToursNewRoute: typeof ToursNewRoute
  VenuesSlugRoute: typeof VenuesSlugRoute
  AdminIndexRoute: typeof AdminIndexRoute
  BrowseIndexRoute: typeof BrowseIndexRoute
  EventsIndexRoute: typeof EventsIndexRoute
  ExchangesIndexRoute: typeof ExchangesIndexRoute
  ExploreIndexRoute: typeof ExploreIndexRoute
  InboxIndexRoute: typeof InboxIndexRoute
  ProfileIndexRoute: typeof ProfileIndexRoute
  RecapsIndexRoute: typeof RecapsIndexRoute
  RipplesIndexRoute: typeof RipplesIndexRoute
  ToursIndexRoute: typeof ToursIndexRoute
  AdminDisputesIdRoute: typeof AdminDisputesIdRoute
  AdminUsersIdRoute: typeof AdminUsersIdRoute
  AdminVerificationsIdRoute: typeof AdminVerificationsIdRoute
  ExchangesIdRecapRoute: typeof ExchangesIdRecapRoute
  ExchangesIdReviewRoute: typeof ExchangesIdReviewRoute
  HostEventsNewRoute: typeof HostEventsNewRoute
  HostVenuesNewRoute: typeof HostVenuesNewRoute
  ToursIdEditRoute: typeof ToursIdEditRoute
  AdminDisputesIndexRoute: typeof AdminDisputesIndexRoute
  AdminUsersIndexRoute: typeof AdminUsersIndexRoute
  AdminVerificationsIndexRoute: typeof AdminVerificationsIndexRoute
  HostEventsIndexRoute: typeof HostEventsIndexRoute
  HostVenuesIndexRoute: typeof HostVenuesIndexRoute
  HostEventsIdManageRoute: typeof HostEventsIdManageRoute
  HostVenuesIdEditRoute: typeof HostVenuesIdEditRoute
  HostVenuesIdPreviewRoute: typeof HostVenuesIdPreviewRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verification': {
      id: '/verification'
      path: '/verification'
      fullPath: '/verification'
      preLoaderRoute: typeof VerificationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-out': {
      id: '/sign-out'
      path: '/sign-out'
      fullPath: '/sign-out'
      preLoaderRoute: typeof SignOutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/our-story': {
      id: '/our-story'
      path: '/our-story'
      fullPath: '/our-story'
      preLoaderRoute: typeof OurStoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/our-ethos': {
      id: '/our-ethos'
      path: '/our-ethos'
      fullPath: '/our-ethos'
      preLoaderRoute: typeof OurEthosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/how-it-works': {
      id: '/how-it-works'
      path: '/how-it-works'
      fullPath: '/how-it-works'
      preLoaderRoute: typeof HowItWorksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/founding-venues': {
      id: '/founding-venues'
      path: '/founding-venues'
      fullPath: '/founding-venues'
      preLoaderRoute: typeof FoundingVenuesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq': {
      id: '/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof FaqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/earlyaccessvenue': {
      id: '/earlyaccessvenue'
      path: '/earlyaccessvenue'
      fullPath: '/earlyaccessvenue'
      preLoaderRoute: typeof EarlyaccessvenueRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/earlyaccessartist': {
      id: '/earlyaccessartist'
      path: '/earlyaccessartist'
      fullPath: '/earlyaccessartist'
      preLoaderRoute: typeof EarlyaccessartistRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/earlyaccess': {
      id: '/earlyaccess'
      path: '/earlyaccess'
      fullPath: '/earlyaccess'
      preLoaderRoute: typeof EarlyaccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dispute-resolution': {
      id: '/dispute-resolution'
      path: '/dispute-resolution'
      fullPath: '/dispute-resolution'
      preLoaderRoute: typeof DisputeResolutionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/community-guidelines': {
      id: '/community-guidelines'
      path: '/community-guidelines'
      fullPath: '/community-guidelines'
      preLoaderRoute: typeof CommunityGuidelinesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing': {
      id: '/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof BillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/availability': {
      id: '/availability'
      path: '/availability'
      fullPath: '/availability'
      preLoaderRoute: typeof AvailabilityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/artist-billing': {
      id: '/artist-billing'
      path: '/artist-billing'
      fullPath: '/artist-billing'
      preLoaderRoute: typeof ArtistBillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tours/': {
      id: '/tours/'
      path: '/tours'
      fullPath: '/tours/'
      preLoaderRoute: typeof ToursIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ripples/': {
      id: '/ripples/'
      path: '/ripples'
      fullPath: '/ripples/'
      preLoaderRoute: typeof RipplesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recaps/': {
      id: '/recaps/'
      path: '/recaps'
      fullPath: '/recaps/'
      preLoaderRoute: typeof RecapsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/': {
      id: '/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof ProfileIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox/': {
      id: '/inbox/'
      path: '/inbox'
      fullPath: '/inbox/'
      preLoaderRoute: typeof InboxIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/explore/': {
      id: '/explore/'
      path: '/explore'
      fullPath: '/explore/'
      preLoaderRoute: typeof ExploreIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/exchanges/': {
      id: '/exchanges/'
      path: '/exchanges'
      fullPath: '/exchanges/'
      preLoaderRoute: typeof ExchangesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events/': {
      id: '/events/'
      path: '/events'
      fullPath: '/events/'
      preLoaderRoute: typeof EventsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/browse/': {
      id: '/browse/'
      path: '/browse'
      fullPath: '/browse/'
      preLoaderRoute: typeof BrowseIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/venues/$slug': {
      id: '/venues/$slug'
      path: '/venues/$slug'
      fullPath: '/venues/$slug'
      preLoaderRoute: typeof VenuesSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tours/new': {
      id: '/tours/new'
      path: '/tours/new'
      fullPath: '/tours/new'
      preLoaderRoute: typeof ToursNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tours/$id': {
      id: '/tours/$id'
      path: '/tours/$id'
      fullPath: '/tours/$id'
      preLoaderRoute: typeof ToursIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/security': {
      id: '/settings/security'
      path: '/settings/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof SettingsSecurityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/referrals': {
      id: '/settings/referrals'
      path: '/settings/referrals'
      fullPath: '/settings/referrals'
      preLoaderRoute: typeof SettingsReferralsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/privacy': {
      id: '/settings/privacy'
      path: '/settings/privacy'
      fullPath: '/settings/privacy'
      preLoaderRoute: typeof SettingsPrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/notifications': {
      id: '/settings/notifications'
      path: '/settings/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof SettingsNotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/earnings': {
      id: '/settings/earnings'
      path: '/settings/earnings'
      fullPath: '/settings/earnings'
      preLoaderRoute: typeof SettingsEarningsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/appearance': {
      id: '/settings/appearance'
      path: '/settings/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof SettingsAppearanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/account': {
      id: '/settings/account'
      path: '/settings/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof SettingsAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ripples/$slug': {
      id: '/ripples/$slug'
      path: '/ripples/$slug'
      fullPath: '/ripples/$slug'
      preLoaderRoute: typeof RipplesSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/request/$venueId': {
      id: '/request/$venueId'
      path: '/request/$venueId'
      fullPath: '/request/$venueId'
      preLoaderRoute: typeof RequestVenueIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recaps/$slug': {
      id: '/recaps/$slug'
      path: '/recaps/$slug'
      fullPath: '/recaps/$slug'
      preLoaderRoute: typeof RecapsSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/edit': {
      id: '/profile/edit'
      path: '/profile/edit'
      fullPath: '/profile/edit'
      preLoaderRoute: typeof ProfileEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/host': {
      id: '/onboarding/host'
      path: '/onboarding/host'
      fullPath: '/onboarding/host'
      preLoaderRoute: typeof OnboardingHostRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/artist': {
      id: '/onboarding/artist'
      path: '/onboarding/artist'
      fullPath: '/onboarding/artist'
      preLoaderRoute: typeof OnboardingArtistRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox/$threadId': {
      id: '/inbox/$threadId'
      path: '/inbox/$threadId'
      fullPath: '/inbox/$threadId'
      preLoaderRoute: typeof InboxThreadIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/host/dashboard': {
      id: '/host/dashboard'
      path: '/host/dashboard'
      fullPath: '/host/dashboard'
      preLoaderRoute: typeof HostDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/host/availability': {
      id: '/host/availability'
      path: '/host/availability'
      fullPath: '/host/availability'
      preLoaderRoute: typeof HostAvailabilityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/explore/$slug': {
      id: '/explore/$slug'
      path: '/explore/$slug'
      fullPath: '/explore/$slug'
      preLoaderRoute: typeof ExploreSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/exchanges/$id': {
      id: '/exchanges/$id'
      path: '/exchanges/$id'
      fullPath: '/exchanges/$id'
      preLoaderRoute: typeof ExchangesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events/$id': {
      id: '/events/$id'
      path: '/events/$id'
      fullPath: '/events/$id'
      preLoaderRoute: typeof EventsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/disputes/open': {
      id: '/disputes/open'
      path: '/disputes/open'
      fullPath: '/disputes/open'
      preLoaderRoute: typeof DisputesOpenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/disputes/$id': {
      id: '/disputes/$id'
      path: '/disputes/$id'
      fullPath: '/disputes/$id'
      preLoaderRoute: typeof DisputesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/certificates/$exchangeId': {
      id: '/certificates/$exchangeId'
      path: '/certificates/$exchangeId'
      fullPath: '/certificates/$exchangeId'
      preLoaderRoute: typeof CertificatesExchangeIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/browse/artists': {
      id: '/browse/artists'
      path: '/browse/artists'
      fullPath: '/browse/artists'
      preLoaderRoute: typeof BrowseArtistsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/artists/$slug': {
      id: '/artists/$slug'
      path: '/artists/$slug'
      fullPath: '/artists/$slug'
      preLoaderRoute: typeof ArtistsSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/venues': {
      id: '/admin/venues'
      path: '/admin/venues'
      fullPath: '/admin/venues'
      preLoaderRoute: typeof AdminVenuesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/sweepers': {
      id: '/admin/sweepers'
      path: '/admin/sweepers'
      fullPath: '/admin/sweepers'
      preLoaderRoute: typeof AdminSweepersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/subscriptions': {
      id: '/admin/subscriptions'
      path: '/admin/subscriptions'
      fullPath: '/admin/subscriptions'
      preLoaderRoute: typeof AdminSubscriptionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/admin/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/reports': {
      id: '/admin/reports'
      path: '/admin/reports'
      fullPath: '/admin/reports'
      preLoaderRoute: typeof AdminReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/referrals': {
      id: '/admin/referrals'
      path: '/admin/referrals'
      fullPath: '/admin/referrals'
      preLoaderRoute: typeof AdminReferralsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/referral-payouts': {
      id: '/admin/referral-payouts'
      path: '/admin/referral-payouts'
      fullPath: '/admin/referral-payouts'
      preLoaderRoute: typeof AdminReferralPayoutsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/leads': {
      id: '/admin/leads'
      path: '/admin/leads'
      fullPath: '/admin/leads'
      preLoaderRoute: typeof AdminLeadsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/launch': {
      id: '/admin/launch'
      path: '/admin/launch'
      fullPath: '/admin/launch'
      preLoaderRoute: typeof AdminLaunchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/image-studio': {
      id: '/admin/image-studio'
      path: '/admin/image-studio'
      fullPath: '/admin/image-studio'
      preLoaderRoute: typeof AdminImageStudioRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/feedback': {
      id: '/admin/feedback'
      path: '/admin/feedback'
      fullPath: '/admin/feedback'
      preLoaderRoute: typeof AdminFeedbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/exchanges': {
      id: '/admin/exchanges'
      path: '/admin/exchanges'
      fullPath: '/admin/exchanges'
      preLoaderRoute: typeof AdminExchangesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/cohort': {
      id: '/admin/cohort'
      path: '/admin/cohort'
      fullPath: '/admin/cohort'
      preLoaderRoute: typeof AdminCohortRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/billing-reconciliation': {
      id: '/admin/billing-reconciliation'
      path: '/admin/billing-reconciliation'
      fullPath: '/admin/billing-reconciliation'
      preLoaderRoute: typeof AdminBillingReconciliationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/audit-log': {
      id: '/admin/audit-log'
      path: '/admin/audit-log'
      fullPath: '/admin/audit-log'
      preLoaderRoute: typeof AdminAuditLogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/announcements': {
      id: '/admin/announcements'
      path: '/admin/announcements'
      fullPath: '/admin/announcements'
      preLoaderRoute: typeof AdminAnnouncementsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/analytics-events': {
      id: '/admin/analytics-events'
      path: '/admin/analytics-events'
      fullPath: '/admin/analytics-events'
      preLoaderRoute: typeof AdminAnalyticsEventsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/analytics': {
      id: '/admin/analytics'
      path: '/admin/analytics'
      fullPath: '/admin/analytics'
      preLoaderRoute: typeof AdminAnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/host/venues/': {
      id: '/host/venues/'
      path: '/host/venues'
      fullPath: '/host/venues/'
      preLoaderRoute: typeof HostVenuesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/host/events/': {
      id: '/host/events/'
      path: '/host/events'
      fullPath: '/host/events/'
      preLoaderRoute: typeof HostEventsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/verifications/': {
      id: '/admin/verifications/'
      path: '/admin/verifications'
      fullPath: '/admin/verifications/'
      preLoaderRoute: typeof AdminVerificationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users/': {
      id: '/admin/users/'
      path: '/admin/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AdminUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/disputes/': {
      id: '/admin/disputes/'
      path: '/admin/disputes'
      fullPath: '/admin/disputes/'
      preLoaderRoute: typeof AdminDisputesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tours/$id_/edit': {
      id: '/tours/$id_/edit'
      path: '/tours/$id/edit'
      fullPath: '/tours/$id/edit'
      preLoaderRoute: typeof ToursIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/host/venues/new': {
      id: '/host/venues/new'
      path: '/host/venues/new'
      fullPath: '/host/venues/new'
      preLoaderRoute: typeof HostVenuesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/host/events/new': {
      id: '/host/events/new'
      path: '/host/events/new'
      fullPath: '/host/events/new'
      preLoaderRoute: typeof HostEventsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/exchanges/$id_/review': {
      id: '/exchanges/$id_/review'
      path: '/exchanges/$id/review'
      fullPath: '/exchanges/$id/review'
      preLoaderRoute: typeof ExchangesIdReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/exchanges/$id_/recap': {
      id: '/exchanges/$id_/recap'
      path: '/exchanges/$id/recap'
      fullPath: '/exchanges/$id/recap'
      preLoaderRoute: typeof ExchangesIdRecapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/verifications/$id': {
      id: '/admin/verifications/$id'
      path: '/admin/verifications/$id'
      fullPath: '/admin/verifications/$id'
      preLoaderRoute: typeof AdminVerificationsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users/$id': {
      id: '/admin/users/$id'
      path: '/admin/users/$id'
      fullPath: '/admin/users/$id'
      preLoaderRoute: typeof AdminUsersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/disputes/$id': {
      id: '/admin/disputes/$id'
      path: '/admin/disputes/$id'
      fullPath: '/admin/disputes/$id'
      preLoaderRoute: typeof AdminDisputesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/host/venues/$id/preview': {
      id: '/host/venues/$id/preview'
      path: '/host/venues/$id/preview'
      fullPath: '/host/venues/$id/preview'
      preLoaderRoute: typeof HostVenuesIdPreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/host/venues/$id/edit': {
      id: '/host/venues/$id/edit'
      path: '/host/venues/$id/edit'
      fullPath: '/host/venues/$id/edit'
      preLoaderRoute: typeof HostVenuesIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/host/events/$id/manage': {
      id: '/host/events/$id/manage'
      path: '/host/events/$id/manage'
      fullPath: '/host/events/$id/manage'
      preLoaderRoute: typeof HostEventsIdManageRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ArtistBillingRoute: ArtistBillingRoute,
  AvailabilityRoute: AvailabilityRoute,
  BillingRoute: BillingRoute,
  CommunityGuidelinesRoute: CommunityGuidelinesRoute,
  DashboardRoute: DashboardRoute,
  DisputeResolutionRoute: DisputeResolutionRoute,
  EarlyaccessRoute: EarlyaccessRoute,
  EarlyaccessartistRoute: EarlyaccessartistRoute,
  EarlyaccessvenueRoute: EarlyaccessvenueRoute,
  FaqRoute: FaqRoute,
  FoundingVenuesRoute: FoundingVenuesRoute,
  HowItWorksRoute: HowItWorksRoute,
  NotificationsRoute: NotificationsRoute,
  OurEthosRoute: OurEthosRoute,
  OurStoryRoute: OurStoryRoute,
  PrivacyRoute: PrivacyRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignInRoute: SignInRoute,
  SignOutRoute: SignOutRoute,
  SignUpRoute: SignUpRoute,
  TermsRoute: TermsRoute,
  VerificationRoute: VerificationRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  AdminAnalyticsRoute: AdminAnalyticsRoute,
  AdminAnalyticsEventsRoute: AdminAnalyticsEventsRoute,
  AdminAnnouncementsRoute: AdminAnnouncementsRoute,
  AdminAuditLogRoute: AdminAuditLogRoute,
  AdminBillingReconciliationRoute: AdminBillingReconciliationRoute,
  AdminCohortRoute: AdminCohortRoute,
  AdminExchangesRoute: AdminExchangesRoute,
  AdminFeedbackRoute: AdminFeedbackRoute,
  AdminImageStudioRoute: AdminImageStudioRoute,
  AdminLaunchRoute: AdminLaunchRoute,
  AdminLeadsRoute: AdminLeadsRoute,
  AdminReferralPayoutsRoute: AdminReferralPayoutsRoute,
  AdminReferralsRoute: AdminReferralsRoute,
  AdminReportsRoute: AdminReportsRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminSubscriptionsRoute: AdminSubscriptionsRoute,
  AdminSweepersRoute: AdminSweepersRoute,
  AdminVenuesRoute: AdminVenuesRoute,
  ArtistsSlugRoute: ArtistsSlugRoute,
  BrowseArtistsRoute: BrowseArtistsRoute,
  CertificatesExchangeIdRoute: CertificatesExchangeIdRoute,
  DisputesIdRoute: DisputesIdRoute,
  DisputesOpenRoute: DisputesOpenRoute,
  EventsIdRoute: EventsIdRoute,
  ExchangesIdRoute: ExchangesIdRoute,
  ExploreSlugRoute: ExploreSlugRoute,
  HostAvailabilityRoute: HostAvailabilityRoute,
  HostDashboardRoute: HostDashboardRoute,
  InboxThreadIdRoute: InboxThreadIdRoute,
  OnboardingArtistRoute: OnboardingArtistRoute,
  OnboardingHostRoute: OnboardingHostRoute,
  ProfileEditRoute: ProfileEditRoute,
  RecapsSlugRoute: RecapsSlugRoute,
  RequestVenueIdRoute: RequestVenueIdRoute,
  RipplesSlugRoute: RipplesSlugRoute,
  SettingsAccountRoute: SettingsAccountRoute,
  SettingsAppearanceRoute: SettingsAppearanceRoute,
  SettingsEarningsRoute: SettingsEarningsRoute,
  SettingsNotificationsRoute: SettingsNotificationsRoute,
  SettingsPrivacyRoute: SettingsPrivacyRoute,
  SettingsReferralsRoute: SettingsReferralsRoute,
  SettingsSecurityRoute: SettingsSecurityRoute,
  ToursIdRoute: ToursIdRoute,
  ToursNewRoute: ToursNewRoute,
  VenuesSlugRoute: VenuesSlugRoute,
  AdminIndexRoute: AdminIndexRoute,
  BrowseIndexRoute: BrowseIndexRoute,
  EventsIndexRoute: EventsIndexRoute,
  ExchangesIndexRoute: ExchangesIndexRoute,
  ExploreIndexRoute: ExploreIndexRoute,
  InboxIndexRoute: InboxIndexRoute,
  ProfileIndexRoute: ProfileIndexRoute,
  RecapsIndexRoute: RecapsIndexRoute,
  RipplesIndexRoute: RipplesIndexRoute,
  ToursIndexRoute: ToursIndexRoute,
  AdminDisputesIdRoute: AdminDisputesIdRoute,
  AdminUsersIdRoute: AdminUsersIdRoute,
  AdminVerificationsIdRoute: AdminVerificationsIdRoute,
  ExchangesIdRecapRoute: ExchangesIdRecapRoute,
  ExchangesIdReviewRoute: ExchangesIdReviewRoute,
  HostEventsNewRoute: HostEventsNewRoute,
  HostVenuesNewRoute: HostVenuesNewRoute,
  ToursIdEditRoute: ToursIdEditRoute,
  AdminDisputesIndexRoute: AdminDisputesIndexRoute,
  AdminUsersIndexRoute: AdminUsersIndexRoute,
  AdminVerificationsIndexRoute: AdminVerificationsIndexRoute,
  HostEventsIndexRoute: HostEventsIndexRoute,
  HostVenuesIndexRoute: HostVenuesIndexRoute,
  HostEventsIdManageRoute: HostEventsIdManageRoute,
  HostVenuesIdEditRoute: HostVenuesIdEditRoute,
  HostVenuesIdPreviewRoute: HostVenuesIdPreviewRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
